import { render, staticRenderFns } from "./auth_detail.vue?vue&type=template&id=b844a576&scoped=true"
import script from "./auth_detail.vue?vue&type=script&lang=ts"
export * from "./auth_detail.vue?vue&type=script&lang=ts"
import style0 from "./auth_detail.vue?vue&type=style&index=0&id=b844a576&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b844a576",
  null
  
)

export default component.exports